<template>
    <div class="checkbox-matrix">
      <table width="100%">
        <thead>
          <tr>
            <th colspan="6"></th>
            <th v-for="col in columns" :key="col"  colspan="4">{{ col }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row,index) in rowLabels" :key="row">
            <td colspan="6" class="text-left">{{ nomineeLabels[index].FullName }} ( {{ nomineeLabels[index].GOM }} ) <a :href="nomineeLabels[index].Link" target="_blank">View Motivation</a></td>
            <td colspan="4" v-for="col in columns" :key="row + '-' + col">
              <input
                type="checkbox"
                :checked="selectedOptions[row] === col"
                :disabled="isColumnSelected(col) && selectedOptions[row] !== col"
                @change="handleCheckbox(row, col)"
              />
            </td>
          </tr>
        </tbody>
      </table>
  
      <!--p><strong>Selected Options:</strong> {{ selectedOptions }}</p-->
    </div>
  </template>
  
  <script>
  export default {
    name: "RadioMatrix",
    props: [
        "label",
        "labelSecondary",
        "isRequired",
        "displayField",
        "errorClass",
        "options",
        "nomineeLabels"
    ],
    data() {
      return {
        rowLabels: [],
        columns: ['option1', 'option2', 'option3'],
        selectedOptions: {},
        linkData: []
      };
    },
    created() {
        this.rowLabels = this.options
        this.selectedOptions = {}
        if (!this.label) {
          this.label = "FieldMCGTemplate"
        }
    },
    methods: {
      handleCheckbox(rowKey, colValue) {
        const current = this.selectedOptions[rowKey]  
        if (current === colValue) {
          // Deselect
          this.$set(this.selectedOptions, rowKey, null);
        } else {
          // Only allow if column not selected elsewhere
          if (!this.isColumnSelected(colValue)) {
            this.$set(this.selectedOptions, rowKey, colValue)
          } else {
            return
          }
        }
        // 🔥 Emit selection to parent after every change
        this.$emit("addedCheckBoxesContent", {
        label: this.label, // Make sure `this.label` exists or pass it as prop
        content: this.selectedOptions,
        validated: true,
        displayField: this.displayField // Make sure this.displayField is defined or passed as prop
        });
      },

      isColumnSelected(colValue) {
        return Object.values(this.selectedOptions).includes(colValue);
      }
    }
  };
  </script>
  
  <style scoped>
  .checkbox-matrix table {
    border-collapse: collapse;
  }
  .checkbox-matrix th,
  .checkbox-matrix td {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: center;
  }
  .text-left {
    text-align: right;
  }
  </style>


// WEBPACK FOOTER //
// src/components/FieldMCGTemplateCheck.vue